<template>
    <main class="register">
        <hk-background></hk-background>
        <div class="register-container">
            <p class="register-container-tab">注册</p>
            <div class="register-form">
                <div class="msg-code">
                    <input
                        v-model="phone"
                        :readonly="readonly"
                        type="text"
                        class="code-input"
                        placeholder="请输入手机号"
                        @focus="removeReadonly"
                    />
                    <input
                        type="button"
                        :disabled="codeBtnState"
                        :value="codeText"
                        class="get-code"
                        @click="debounceSendSms"
                    />
                </div>
                <hk-password-input
                    v-model="password"
                    placeholder="请设置8~32位的数字、字母组合密码"
                    :reg="reg"
                ></hk-password-input>
                <input
                    v-model="code"
                    type="text"
                    autocomplete="off"
                    class="phone"
                    placeholder="请输入验证码"
                />
                <input v-model="userName" type="text" class="user-name" placeholder="请输入姓名" />
                <input v-model="school" type="text" class="school" placeholder="请输入学校名称" />
                <el-select v-model="grade" placeholder="请选择年级">
                    <el-option
                        v-for="item in grades"
                        :key="item.grade"
                        :label="item.label"
                        :value="item.grade"
                    >
                    </el-option>
                </el-select>
                <hk-button
                    text="立即注册"
                    :customStyle="buttonStyle"
                    :height="50"
                    @handleClick="submit"
                ></hk-button>
            </div>
        </div>

        <HkDialogCaptcha
            :state.sync="captchaDlgVisible"
            title=""
            buttonText="确定"
            @close="closeCaptchaDialog"
            @confirm="onCaptchaConfirm"
        >
            <template #content>
                <div class="captcha">
                    <p>验证码：<input v-model="captcha" maxlength="10" type="text" /></p>
                    <p class="hint">输入下图中的字符，不区分大小写</p>
                    <div class="image">
                        <img :src="captchaUrl" alt="" />
                        <input type="button" value="看不清，换一张" @click="getCaptchaInfo" />
                    </div>
                </div>
            </template>
        </HkDialogCaptcha>
    </main>
</template>

<script>
import HkBackground from '@components/HkBackground';
import HkPasswordInput from '@components/HkPasswordInput';
import HkButton from '@components/HkButton';
import { isNotEmpty, isPhone, validatePassword } from '@helpers/validation';
import { debounce } from 'lodash';
import { sendSms, captchaInfo } from '@api/common';
import { register } from '@api/auth';
import { SET_TOKEN } from '@constants/store';
import { LOGINED, LOGIN_STATUS } from '@constants/common';
import Cookies from 'js-cookie';
import HkDialogCaptcha from '@components/HkDialogCaptcha';

export default {
    components: {
        HkBackground,
        HkPasswordInput,
        HkButton,
        HkDialogCaptcha
    },
    data() {
        return {
            readonly: true,
            phone: '',
            code: '',
            password: '',
            codeText: '发送验证码',
            codeBtnState: false,
            timer: '',
            time: 60,
            reg: /^(?![^a-zA-Z]+$)(?!\D+$)\w{8,32}$/,
            debounceSendSms: null,
            userName: '',
            grade: '',
            school: '',
            grades: [
                { grade: 1, label: '一年级' },
                { grade: 2, label: '二年级' },
                { grade: 3, label: '三年级' },
                { grade: 4, label: '四年级' },
                { grade: 5, label: '五年级' },
                { grade: 6, label: '六年级' },
                { grade: 7, label: '初一' },
                { grade: 8, label: '初二' },
                { grade: 9, label: '初三' },
                { grade: 10, label: '高一' },
                { grade: 11, label: '高二' },
                { grade: 12, label: '高三' }
            ],
            buttonStyle: {
                width: '100%',
                color: '#fff',
                shadowColor: '#D695DE',
                background: true,
                startColor: '#89009A',
                endColor: '#A60AAC'
            },

            captchaDlgVisible: false, // 验证码对话框是否可见
            captcha: '', // 图形验证码
            captchaSessionId: '',
            captchaUrl: '' // 图形验证码URL
        };
    },

    computed: {},

    created() {
        this.debounceSendSms = debounce(this.sendCode, 1000, {
            leading: true,
            trailing: false
        });
    },

    mounted() {},

    methods: {
        validatePhone() {
            if (isPhone(this.phone)) {
                return true;
            }

            this.$message.error('请输入手机号码');
            return false;
        },
        validateCode() {
            if (isNotEmpty(this.code)) {
                return true;
            }

            this.$message.error('请输入验证码');
            return false;
        },
        validatePass() {
            if (validatePassword(this.password)) {
                return true;
            }

            this.$message.error('请设置8~32位的数字、字母组合密码');
            return false;
        },
        validateName() {
            if (isNotEmpty(this.userName)) {
                return true;
            }
            this.$message.error('请输入姓名');
        },
        validateSchool() {
            if (isNotEmpty(this.school)) {
                return true;
            }
            this.$message.error('请输入学校名称');
            return false;
        },
        validateGrade() {
            if (this.grade) {
                return true;
            }
            this.$message.error('请选择年级');
            return false;
        },
        removeReadonly() {
            this.readonly = false;
        },
        clearTimer() {
            clearInterval(this.timer);
            this.timer = null;
            this.codeText = '发送验证码';
            this.codeBtnState = false;
            this.time = 60;
        },
        async sendCode() {
            if (this.validatePhone()) {
                this.getCaptchaInfo();
            }
        },
        async submit() {
            const { phone, code, password, userName, grade, school } = this;
            if (
                this.validatePhone() &&
                this.validateCode() &&
                this.validatePass() &&
                this.validateName() &&
                this.validateSchool() &&
                this.validateGrade()
            ) {
                const data = await register({
                    cellphone: phone,
                    code,
                    password,
                    name: userName,
                    school,
                    grade
                });
                if (data.code === 0) {
                    this.$store.commit(SET_TOKEN, data.access_token);
                    Cookies.set(LOGIN_STATUS, LOGINED);
                    await this.$store.dispatch('queryUserInfo');
                    this.$router.push({ name: 'HomePage' });
                }
            }
        },
        // 获取验证码信息
        async getCaptchaInfo() {
            try {
                const resp = await captchaInfo();
                this.captchaUrl = resp.data.captcha_url;
                this.captchaSessionId = resp.data.session_id;

                this.captchaDlgVisible = true;
            } catch {
                this.$message.error('获取验证码失败');
            }
        },
        // 关闭验证码对话框
        closeCaptchaDialog() {
            this.captchaDlgVisible = false;
        },
        // 验证码对话框确定事件处理
        async onCaptchaConfirm() {
            this.captcha = this.captcha.trim();
            if (!this.captcha) {
                this.$message.error('请输入图形验证码');
                return;
            }

            this.captchaDlgVisible = false;

            this.codeBtnState = true;

            try {
                await sendSms(this.phone, this.captcha, this.captchaSessionId, 3);
                this.codeText = `${this.time}s`;
                this.timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--;
                        this.codeText = `${this.time}s`;
                    } else {
                        this.clearTimer();
                    }
                }, 1000);
            } catch {
                this.codeBtnState = false;
                this.captcha = '';
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.register {
    width: 100%;
    height: 100vh;
    min-height: 800px;
    margin: 0 auto;
    position: relative;
    &-container {
        box-sizing: border-box;
        width: 482px;
        min-height: 534px;
        background: #fff;
        box-shadow: -3px 2px 32px 0px #eaeaea;
        position: absolute;
        top: 100px;
        right: 336px;
        z-index: 99;
        padding: 82px 50px 50px;
        &-tab {
            width: 100%;
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #312e33;
            margin-right: 40px;
            padding-bottom: 28px;
            user-select: none;
            border-bottom: 1px solid #ededed;
            margin-bottom: 38px;
        }
        input[type='text'] {
            box-sizing: border-box;
            width: 100%;
            height: 46px;
            background: #f4f4f4;
            border: none;
            outline: none;
            margin-bottom: 26px;
            color: #a0a0a0;
            font-size: 14px;
            padding: 0 20px;
        }
        .msg-code {
            position: relative;
            .get-code {
                position: absolute;
                right: 20px;
                top: 0;
                border: none;
                outline: none;
                width: 70px;
                height: 46px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #cccbcb;
                padding: 0;
                cursor: pointer;
                background: #f4f4f4;
            }
            .code-input {
                padding: 0 110px 0 20px;
            }
        }
        ::v-deep {
            .el-select {
                width: 100%;
                margin-bottom: 26px;
                .el-input__inner {
                    height: 46px;
                    background: #f4f4f4;
                    border: none;
                    color: #a0a0a0;
                }
            }
        }
    }

    .captcha {
        & > p {
            font-size: 16px;

            & > input {
                box-sizing: border-box;
                height: 46px;
                background: #f4f4f4;
                border: none;
                outline: none;
                color: #a0a0a0;
                font-size: 16px;
                padding: 0 20px;
            }
        }

        .hint {
            color: #7b7d7c;
            margin-left: 46px;
            margin-top: 4px;
            font-size: 14px;
        }

        .image {
            margin: 10px 0 20px 90px;

            & > img {
                max-width: 150px;
                max-height: 40px;
            }

            & > input {
                color: #729c9b;
                outline: none;
                border: 0;
                background: transparent;
                cursor: pointer;
            }
        }
    }
}
</style>
